import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DayJsConfig } from '@rd-lib/dayjs.config';
import { Locale } from '@rd/types';
import relativeTime from 'dayjs/plugin/relativeTime';
import { DateService } from '../date/date.service';

@Injectable({
  providedIn: 'root',
})
export class TimeService {
  currentLocale: Locale | null;

  constructor(
    private dateService: DateService,
    private translateService: TranslateService,
  ) {
    // extend here to let the local dateService.dayjs has 'relativeTime' enabled
    this.dateService.dayjs.extend(relativeTime, DayJsConfig.relativeTimeConfig);
  }

  timeFromNow(timeInSeconds: number): string {
    // withoutSuffix means without the "in" word in "in 2 hours"
    // append "ago" for times in the past (ex: 14 days ago)
    const withoutSuffix = timeInSeconds > 0;
    if (timeInSeconds !== 0) {
      return this.dateService
        .dayjs()
        .add(timeInSeconds, 'second')
        .fromNow(withoutSuffix);
    } else {
      return this.translateService.instant(
        'transfer.checkout.estimated_transfer_time_instant',
      );
    }
  }
}
